import { Receiver } from "./Receiver";

// Create new sample Receiver.
const receiver = new Receiver();

// Start receiving requests from senders.
receiver.start();
